import React, { useEffect, useState } from 'react'
import AppLayout from '../../../../layout/components/AppLayout'
import { Dialog, DialogActions, DialogContent } from '@mui/material'
import barcodeServices from '../barcodeServices';
import GenerateNewBatchComponent from '../components/GenerateNewBatchComponent';
import BarcodeBatchListComponent from '../components/BarcodeBatchListComponent';
import PrintLabelComponent from '../components/PrintLabelComponent';

function BarcodeManagerPage() {

    
    const [batchList,setBatchList] = useState(null);
    const [barcodeList,setBarcodeList] = useState(null);
    const [selectedBatch,setSelectedBatch] = useState(null);

    const getBarcodeList = () => {
        if(selectedBatch !== null){
            barcodeServices.getByBatchId(selectedBatch).then(res=>{
                setBarcodeList(res.data);
            }).catch(error=>{
    
            })
        }        
    }
    useEffect(()=>{
        getBarcodeList();
    },[selectedBatch])

    const getBatchList = () => {
        barcodeServices.getBatchList().then(res=>{
            setBatchList(res.data);
        }).catch(error=>{
        })
    }

    useEffect(()=>{
        getBatchList();
    },[])
    
    return (
        <AppLayout>
            <div className='container-fluid'>
                <GenerateNewBatchComponent setSelectedBatch={setSelectedBatch} onSuccess={getBatchList} />
                {batchList && <BarcodeBatchListComponent batchList={batchList} setSelectedBatch={setSelectedBatch} /> }
                {barcodeList && <PrintLabelComponent barcodeList={barcodeList} /> }
            </div>
        </AppLayout>
    )
}

export default BarcodeManagerPage